import { render, staticRenderFns } from "./CasesList.vue?vue&type=template&id=24ad185e"
import script from "./CasesList.vue?vue&type=script&lang=js"
export * from "./CasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports